import { ConfirmationDialog } from 'components/Confirmation';
import Linkify from 'linkify-react';
import { useState } from 'react';

interface TextWithLinksProps {
  children?: React.ReactNode;
  linkClassName?: string;
}

export const TextWithLinks = ({
  children,
  linkClassName = 'text-secondary',
}: TextWithLinksProps) => {
  const [verifyHref, setVerifyHref] = useState<string | null>(null);

  return (
    <>
      <ConfirmationDialog
        title={'Du er ved at forlade siden'}
        description={`Du er ved at åbne et eksternt link: ${
          verifyHref && verifyHref.length > 50
            ? `${verifyHref.slice(0, 50)}...`
            : verifyHref
        }. 
Linket vil blive åbnet i en ny fane. 
Vi kan ikke garantere indholdet på eksterne sider.`}
        showModal={() => !!verifyHref}
        isOpen={!!verifyHref}
        onConfirm={() => {
          if (verifyHref) {
            window.open(verifyHref, '_blank', 'noopener,noreferrer');
          }
          setVerifyHref(null);
        }}
        onCancel={() => setVerifyHref(null)}
        confirmText="Åbn link"
        cancelText="Forbliv her"
      />

      <Linkify
        options={{
          target: '_blank',
          rel: 'noopener noreferrer',
          className: linkClassName,
          attributes: {
            onClick: (e: Event) => {
              if (!isInternalLink((e.target as HTMLAnchorElement).href)) {
                setVerifyHref((e.target as HTMLAnchorElement).href);
                e.preventDefault();
              }
            },
          },
        }}
      >
        {children}
      </Linkify>
    </>
  );
};

const allowedDomains = [
  'openomic.dk',
  'smartcreate.dk',
  'estateengine.dk',
  'edc.dk',
  'nybolig.dk',
  'home.dk',
  'danbolig.dk',
  'boligsiden.dk',
  'boliga.dk',
  'localhost',
  'atlassian.net',
];

const isInternalLink = (href: string) => {
  try {
    const url = new URL(href);
    return allowedDomains.some(
      (domain) => url.hostname === domain || url.hostname.endsWith(`.${domain}`)
    );
  } catch {
    return false;
  }
};
